import React from 'react';
import { useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';
import Colors from '../../constants/Colors';
import Button from '../../components/Button';
import { Formik } from 'formik';
import Form from '../../components/form/Form';
import FormTimeInput from '../../components/form/FormTimeInput';
import { log } from '../../tools/LogHelper';
import { stringify } from 'flatted';

const StyledView = styled.View<{
  isDesktop: boolean;
}>`
  background: ${Colors.background};
  height: 100%;
  padding-top: 100px;
  padding-left: 32px;
  padding-right: 32px;
  align-items: center;
  width: 100%;
`;

const StyledButton = styled(Button)`
  margin-top: 16px;
`;

const TimePickerScreen: React.FC = () => {
  const window = useWindowDimensions();
  const isDesktop = window.width >= 768;

  return (
    <StyledView isDesktop={isDesktop}>
      <Formik
        initialValues={{}}
        onSubmit={values => {
          log(stringify(values));
        }}
      >
        {values => (
          <Form>
            <FormTimeInput name='time' />
            <StyledButton onPress={() => values.submitForm()}>
              Submit
            </StyledButton>
          </Form>
        )}
      </Formik>
    </StyledView>
  );
};

export default TimePickerScreen;
